export const Auth = [
  {
    path: '/login',
    name: 'auth.index',
    component: () => import('@/pages/Auth/AuthHome'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/email',
    name: 'auth.email',
    component: () => import('@/pages/Auth/AuthEmail'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/checkMail',
    name: 'auth.checkMail',
    component: () => import('@/pages/Auth/AuthConfirm'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/confirmEmail',
    name: 'auth.confirmEmail',
    component: () => import('@/pages/Auth/AuthEmailConfirmed'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/finish',
    name: 'auth.register',
    component: () => import('@/pages/Auth/AuthRegister'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/auth-finish',
    name: 'auth.authFinish',
    component: () => import('@/pages/Auth/AuthFinish'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/forgot-password',
    name: 'auth.forgotPass',
    component: () => import('@/pages/Auth/AuthReset'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/resetPassword',
    name: 'auth.resetPass',
    component: () => import('@/pages/Auth/AuthResetConfirmed'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/confirmInvite',
    name: 'auth.confirmInvite',
    component: () => import('@/pages/Auth/AuthConfirmInvite'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/resetPassword/success',
    name: 'auth.resetPassSuccess',
    component: () => import('@/pages/Auth/AuthResetSuccess'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/login/resetPassword/error',
    name: 'auth.resetPassError',
    component: () => import('@/pages/Auth/AuthResetError'),
    meta: {
      authFlow: true
    }
  },
  {
    path: '/logout',
    name: 'auth.logout',
    component: () => import('@/pages/Auth/LogOut')
  }
]
